const ServiceDescription = {
  name: 'The key of the service',
  description: 'The title of the service',
  service_period_type_cycle: 'Eligibility period is for a fixed / infinite number of billing cycles since subscribing to the service. Service price / includes are per cycle.',
  service_period_type_custom_period: 'Service is charged once for the whole period. Includes are valid for the whole defined period and are independent of the billing cycle.',
  include_counters_groups: 'Service monetary counter groups.',
};

export default ServiceDescription;
